import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';

import { isExpired } from 'App/utils';

const NameCellStyle = styled.div`
    color: ${({ assessment }) =>
        isExpired(assessment.retiredOn) || assessment.settings?.settings.hide || assessment.disabledBy
            ? 'var(--brandDanger)'
            : undefined};
`;

const NameCell = ({ cell: { value }, row: { original } }) => {
    return <NameCellStyle assessment={original}>{value}</NameCellStyle>;
};

NameCell.propTypes = {
    cell: PropTypes.shape({
        value: PropTypes.string,
    }).isRequired,
    row: PropTypes.shape({
        original: PropTypes.shape({}),
    }).isRequired,
};

export default NameCell;
